import { create } from 'zustand';

// Playback health of the exercise page's reference <video>, written from the
// element's own `waiting` / `playing` / `error` events in videos-section and
// read by the patient-facing connection status (use-connection-status). UI state
// only: nothing here touches how or when the video is fetched.
export const useReferenceVideoStatus = create(set => ({
  // Date.now() of the last `waiting` with no `playing` after it.
  waitingSince: null,
  hasError: false,
  markWaiting: () =>
    set(state => (state.waitingSince === null ? { waitingSince: Date.now() } : state)),
  markPlaying: () => set({ waitingSince: null, hasError: false }),
  // A paused element is not buffering in any way the patient sees; an error stays.
  clearWaiting: () => set({ waitingSince: null }),
  markError: () => set({ waitingSince: null, hasError: true }),
  reset: () => set({ waitingSince: null, hasError: false }),
}));
